export default __webpack_public_path__ + "static/media/src - Shortcut.bfa3f197.lnk";